import { render, staticRenderFns } from "./NotAuth.vue?vue&type=template&id=5ef812fc"
import script from "./NotAuth.vue?vue&type=script&lang=js"
export * from "./NotAuth.vue?vue&type=script&lang=js"
import style0 from "./NotAuth.vue?vue&type=style&index=0&id=5ef812fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports